import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 200px;
  background: ${(props) => props.theme.colors.surface_muted};
  border-radius: 6px;
  min-width: fit-content;

  .avatar {
    width: 52px;
    height: 52px;

    img {
      border-radius: 6px 0 0 6px;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 3px;

    .title {
      font-size: 16px;
      padding-bottom: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 135px;
    }

    .subtitle {
      font-size: 13px;
      color:  ${(props) => props.theme.colors.inactive};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 135px;
      line-height: 17px;
    }
  }
`;

export default { Wrapper };
